import React from "react";
import "./Minimal.css";

const Info = () => (
  <main className="sr-page">
    <div className="sr-bottom">
      {/* <p>Product creator / Art direction</p> */}
      <p>London, UK</p>
      <p>
        <a href="mailto:contact@stevenroberts.info">contact@stevenroberts.info</a>
      </p>
    </div>
  </main>
);

export default Info;